import store from '@/store'
import axios from 'axios'

export default class Api {
	constructor() {
		this.isLoading = false;
		this.isError = false;
		this.error = null;
		this.url = null;
		this.query = null;
		this.baseUrl = null;
		this.method = "get";
		this.headers = {};
		this.params = {};
		this.info = null;
		this.data = null;
		this.callbackCompleted = () => {};
	}
	callbackReset() {
		this.isLoading = true;
		this.isError = false;
		this.error = null;
	} 
	callbackError(e) {
		this.isLoading = false;
		this.isError = true;
		this.error = e;
		if(this.onCallbackErrorCompleted) {
			this.onCallbackErrorCompleted(e);
		}
	}
	callbackSuccess(resp) {
		this.isLoading = false;
		if(resp.data) this.setData(resp.data);
		if(resp.info) this.setInfo(resp.info);
		if(this.callbackCompleted) this.callbackCompleted(resp);
	}
	setData(data) {
		this.data = data;
	}
	setMethod(method) {
		this.method = method;
	}
	setInfo(info) {
		this.info = info;
	}
	setUrl(url) {
		this.baseUrl = url;
		this.url = (this.query) ? `${this.baseUrl}?${this.query}` : this.baseUrl;
	}
	setHeaders(headers) {
		this.headers = headers;
	}
	setParams(params) {
		this.params = params;
	}
	setQuery(query) {
		this.query = query;
		this.url = (this.query) ? `${this.baseUrl}?${this.query}` : this.baseUrl;
	}
	setCallbackError(func) {
		this.onCallbackErrorCompleted = func;
	}
	setCallbackCompleted(func) {
		this.callbackCompleted = func;
	}
	async fetch() {
		//BOC:[auto insert token]
		// The developer console runs on a separate auth track. While the current
		// route is inside it (devAuth.active), always use the developer token;
		// otherwise use the normal user token. This keeps the two sessions from
		// ever cross-contaminating, even if both exist in the same browser.
		const devAuth = store.state.devAuth
		const useDevToken = !!(devAuth && devAuth.active && devAuth.data && devAuth.data.token)
		const bearerToken = useDevToken ? devAuth.data.token : store.state.auth.data.token
		if (typeof bearerToken != 'undefined' && Object.keys(this.headers).length == 0) this.headers.Authorization = 'Bearer ' + bearerToken
		//EOC
		try {
			if(!this.url) return this.callbackError('API is missing. Please contact system developer.')
			this.callbackReset();
			await axios({
				method: this.method,
				headers: this.headers,
				url: this.url,
				data: this.params,
			})
			.then(
				(response) => {
					if (response.data == null) {
						this.callbackError('Item not found.');
					} else if (response.data.error) {
						this.callbackError(response.data.error);
					} else {
						this.callbackSuccess(response.data);
					}
				},
				(error) => {
					if (typeof error.response != 'undefined' && typeof error.response.data != 'undefined') {
						var err;
						if (typeof error.response.data.errors != 'undefined' && error.response.data.errors) {
							//read Laravel ValidationException errors message
							var errors = error.response.data.errors;
							err = errors[Object.keys(errors)[0]];
						} else if (typeof error.response.data.message != 'undefined') {
							err = error.response.data.message;
							if(!err) err = "Error. Received blank error message from server."
						} else {
							err = error;
						}
						//BOC:[session expired - trigger global re-login dialog]
						const httpStatus = (typeof error.response != 'undefined') ? error.response.status : undefined;
						const errStr = (typeof err == 'string') ? err.toLowerCase() : '';
						if (useDevToken) {
							// Developer console runs on a short-lived dev JWT. When it
							// expires or becomes invalid the backend auth guard can't resolve
							// a user: the request fails with 401/403, and is sometimes
							// surfaced as a raw "Cannot read properties of null (reading
							// 'role')" TypeError. Any of these means the dev session is dead,
							// so clear it — LayoutDeveloperConsole watches devAuth and bounces
							// to /developer/login, logging the user out. Replace the cryptic
							// backend message with a clear one.
							const devSessionDead =
								httpStatus === 401 ||
								httpStatus === 403 ||
								errStr.includes('authorization token expired') ||
								errStr.includes('token expired') ||
								errStr.includes('unauthorized') ||
								errStr.includes("reading 'role'") ||
								errStr.includes('reading "role"');
							if (devSessionDead) {
								store.commit('updateDevAuth', false);
								return this.callbackError('Your developer session has expired. Please log in again.');
							}
						} else if (errStr.includes('authorization token expired')) {
							store.commit('updateSessionExpired', true);
						}
						//EOC
						this.callbackError(err);
					} else {
						this.callbackError(error);
					}
				}
			);
		} catch (e) {
			this.callbackError(e);
		}
	}
}